import * as React from "react"

import { cn } from "../../lib/utils"

const cardStyles = {
  header: "grid items-start gap-1 rounded-md px-4",
  title: "text-base font-medium leading-snug [[data-slot=card][data-size=sm]_&]:text-sm [[data-slot=card][data-size=sm]_&]:leading-sm",
  description: "text-sm leading-sm text-muted-foreground",
  action: "self-start",
  content: "px-4 [[data-slot=card][data-size=sm]_&]:px-3",
  footer: "flex items-center px-4 pb-0 pt-4 [[data-slot=card][data-size=sm]_&]:px-3 [[data-slot=card][data-size=sm]_&]:pt-3",
}

function Card({
  className,
  size = "default",
  ...props
}: React.ComponentProps<"div"> & { size?: "default" | "sm" }) {
  return (
    <div
      data-slot="card"
      data-size={size}
      className={cn(
        "flex flex-col gap-4 overflow-hidden rounded-lg border border-border bg-card py-4 text-sm leading-sm text-card-foreground",
        size === "sm" && "py-3",
        className,
      )}
      {...props}
    />
  )
}

function CardHeader({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-header"
      className={cn(cardStyles.header, className)}
      {...props}
    />
  )
}

function CardTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-title"
      className={cn(cardStyles.title, className)}
      {...props}
    />
  )
}

function CardDescription({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-description"
      className={cn(cardStyles.description, className)}
      {...props}
    />
  )
}

function CardAction({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-action"
      className={cn(cardStyles.action, className)}
      {...props}
    />
  )
}

function CardContent({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-content"
      className={cn(cardStyles.content, className)}
      {...props}
    />
  )
}

function CardFooter({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="card-footer"
      className={cn(cardStyles.footer, className)}
      {...props}
    />
  )
}

export {
  Card,
  CardHeader,
  CardFooter,
  CardTitle,
  CardAction,
  CardDescription,
  CardContent,
}
